import React, { useEffect, useState } from "react";
import { Modal as AntModal, Form, Input } from "antd";
import { Button } from "./Button";
import style from "./modal.module.sass";
import { ReactComponent as CloseIcon } from "../../../src/assets/svg/ai-agents/closebtn.svg"
import { ReactComponent as CautionIcon } from "../../../src/assets/svg/danger.svg";

type Footer =
  | {
    enable: true;
    okText: string;
    cancelText: string;
    onOk: any;
    disableOkButton?: boolean;
    disableOkButtonClass?: string;
    OkButtonColor?: "shadow-secondary" | "shadow-primary";
  }
  | {
    enable: false;
    disableOkButtonClass?: string;
    OkButtonColor?: "shadow-secondary" | "shadow-primary";
  };

type DeleteOptions = {
  validateString: string | undefined;
  type: string;
  terms?: string[];
};

interface IProps {
  id?: string;
  title?: any;
  onCancel: any;
  unmountOnCancel: boolean;
  visible: boolean;
  footer: Footer;
  className?: string;
  deleteOptions?: DeleteOptions;
  closable?: boolean;
  width?: string;
  children?: any;
  style?: {};
  loading?: boolean;
  dataTestId?: any;
}

export const Modal = (props: IProps) => {
  const color = props.footer.OkButtonColor || (props.deleteOptions ? "shadow-secondary" : "shadow-primary");
  const [error, setError] = useState<boolean>(false);
  const [errorMsg, setErrorMsg] = useState<string>("");
  const [value, setValue] = useState<string>("");
  const [loading, setLoading] = useState<any>(false);
 const { disableOkButtonClass = ""} = props.footer
  useEffect(() => {
    setLoading(props.loading);
  }, [props.loading]);

  const handleOk = () => {
    // setLoading(true);
    if (props.deleteOptions) {
      if (value === "") {
        setError(true);
        setErrorMsg("Please enter a value");
        setLoading(false);
      } else if (value !== props.deleteOptions.validateString) {
        setError(true);
        setErrorMsg("Incorrect value");
        setLoading(false);
      } else {
        setError(false);
        props.footer && props.footer.enable && props.footer.onOk();
      }
    } else {
      if (!loading) {
        props.footer && props.footer.enable && props.footer.onOk();
      }
    }
  };

  const getModalHeight = () => {
    let finalStyle: React.CSSProperties = {
      height: "calc(100% - 100px)",
    };
    if (props.style) {
      finalStyle = {
        ...finalStyle,
        ...props.style,
      };
    }
    return finalStyle;
  };

  const inputStyles: React.CSSProperties = {
    ...props.deleteOptions?.type === "Branch" ? { width: "86%", margin: "0px 35px", borderColor: "#D9D9D9" } : { width: "50%" }
  }

  const errorMessageStyles: React.CSSProperties = {
    ...props.deleteOptions?.type === "Branch" && { marginLeft: "35px" },
  }

  return (
    <AntModal
      data-test-id={props.dataTestId}
      key={props.id}
      className={`override-modal ${props.className}`}
      title={props.title}
      closeIcon={props.deleteOptions?.type === "Branch" && <CloseIcon />}
      onCancel={props.onCancel}
      destroyOnClose={props.unmountOnCancel}
      closable={props.closable}
      width={props.width}
      style={getModalHeight()}
      // bodyStyle={getModalHeight()}
      footer={
        props.footer.enable
          ? [
            <>
              <Button style={{background: "white", boxShadow: "none", color: "#51808C"}} dataTestId="cancel" color="light" size="small" onClick={props.onCancel}>
                {props.footer.cancelText}
              </Button>
              <Button
                dataTestId="ok"
                color={color}
                style={{ background: "#15808C" }}
                size="small"
                disabled={props.footer.disableOkButton}
                loading={loading}
                onClick={handleOk}
                className={loading && style[disableOkButtonClass]}
              >
                {props.footer.okText}
              </Button>
            </>,
          ]
          : null
      }
      visible={props.visible}
      maskClosable={false}
    >
      {!props.deleteOptions ? (
        props.children
      ) : (
        <div className={style.deleteContainer}>
          { props.deleteOptions.type === "Branch" ? <div className={style.branchname}>Do you want to Permanently delete: <span className={style.branchname_span}>{props.deleteOptions.validateString}</span> branch?</div> : <div className={style.name}>{props.deleteOptions.validateString}</div> }
          <div
            data-test-id="confirmation"
            className={props.deleteOptions.type === "Branch" ? style.confirmationBranch : style.confirmation}
          >
            {props.deleteOptions.type === "Branch" ? <p className={style.branchNameP}>Branch Name<span className={style.branNameRequired}>*</span></p> : `Please confirm ${props.deleteOptions.type.includes("Bpmn") ? props.deleteOptions.type.replace("Bpmn", "journey") : props.deleteOptions.type.toLowerCase()} name to delete`}</div>
          <Form>
            <Form.Item
              validateStatus={error ? "error" : undefined}
              help={
                error ? (
                  <div style={errorMessageStyles}>{errorMsg}</div>
                ) : undefined
              }
            >
              <Input
                data-test-id="name"
                placeholder={props.deleteOptions.type === "Branch" ? "Enter branch name" : ""}
                style={inputStyles}
                onChange={(e) => {
                  setError(false);
                  setValue(e.target.value.trim());
                }}
              />
            </Form.Item>
          </Form>
          {props.deleteOptions.terms && props.deleteOptions.terms.length > 0 ? (
            <div className={style.terms}>
              <div className={style.termsHeader}>
                This change is irreversible
              </div>
              <ul className={style.termsItemContainer}>
                {props.deleteOptions.terms.map(
                  (item: string, index: number) => {
                    return <li data-test-id={`terms_item${item}`} className={style.termsItem}>{item}</li>;
                  }
                )}
              </ul>
            </div>
          ) : null}
            {props.deleteOptions.type === "Branch" &&
              <div className={style.warningdiv}>
                <div>
                  <CautionIcon width={24} height={24} />
                </div>
                <div>
                  <p className={style.warningPTag}>
                    <b>Warning:</b> This action cannot be undone. All changes in this branch will be lost. Make sure important work is merged or backed up.
                  </p>
                </div>
              </div>
            }
        </div>
      )}
    </AntModal>
  );
};
